

<template>
  <div class="container" style="margin-top: 42px;">
    <el-row class="faq-container" style="padding:0 110px 48px 0;">
      <el-col v-for="(faq, index) in faqs" :key="index" :span="12">
        <div class="faq-item" @click="handleClick(faq)">
          <h3 class="show-ellipsis">{{ faq.question }}</h3>
            <div class="faq-answer show-ellipsis">
               <i>答</i> A: {{ faq.answer }}
            </div>
        </div>
      </el-col>
    </el-row>
  </div>

</template>
<script>

export default {
props:{
  activeName:{
    type:String
  }
},
components: {

},
created() {
 
},
data() {
  return {
    faqs: [
    {
      id:'1',
      question: '【海运】货到港后清关方面有什么需要注意？清关时效怎样？',
      answer: '接到客户订单以后，我们专业客服同事会根据目的港代理提供的参考范围替客户审核发票金额，避免到港后目的港海关对发票金额提出异议重新审核而耽误清关时间。我司在以上八个目的港国家均有专业资质、经验丰富的报关行及时代理清关，保证及时有效的清关时效。'
    },
    {
      id:'2',
      question: '【签约】什么样的物流合同才算是公平公正的合同？',
      answer: '1、把报价表中没有但却很重要的内容都放进去的合同；2、双方把出现最坏情况的权责利都事先约定好的合同；'
    },
    {
      id:'3',
      question: '【国际快递】非亚马逊的货物，是否还需要做DDP出货？',
      answer: '收件方是直接收件人的，没有要求必须做预付还是到付，可以自由选择。'
    },
    {
      id:'4',
      question: '【欧洲专线】自由税号怎么清关？税单出来要多长时间？',
      answer: '客户自有税号我们单票清关，单票出税单，税单显示客户的税号，单票小于1000KG的我们选择快递派送，单票大约1000KG的我们选择卡车派送。税单出来的时间为1-2个月。'
    },
    {
      id:'5',
      question: '【清关】清关会需要收件人协助吗？',
      answer: '一般不需要，我司会统一安排清关。'
    },
    {
      id:'6',
      question: '【清关】欧洲哪些类别的产品清关会有特殊要求？',
      answer: '根据我司多年欧洲的清关经验，手机、自行车及其配件、纺织品、鞋子、蓝牙产品、电器类大件产品、部分LED产品清关会有特殊要求（关税较高或有反倾销税或需要提供认证证书），具体发货前请咨询我司客服人员。'
    },
    // 其他的FAQ对象...
  ]
  };
},
methods: {
  handleClick(item){
      console.log(item,this.activeName,'item,activeName')
      this.$router.push({
        path:'/questionDetail',
        query:{
          id:item.id,
          activeName:this.activeName
        }
      })
    }
}

};
</script>
<style src="../index.css" scoped>


</style>